// extracted by mini-css-extract-plugin
export default {"header":"Header_header__eBcny","container":"Header_container__O8vAX","title":"Header_title__djY0o","languageButton":"Header_languageButton__ttJup"};